import React from 'react';
import PropTypes from 'prop-types';

export default function DetailStats({ stats }) {
  return (
    <div className="detail-stats">
      {stats.filter(Boolean).map(({ label, value }) => (
        <div className="detail-stat" key={label}>
          <span className="detail-stat-label">{label}</span>
          <span className="detail-stat-value">{value}</span>
        </div>
      ))}
    </div>
  );
}

DetailStats.propTypes = {
  stats: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.node }))
};
